<!--
参数：
otherColumn:是否显示性别、年龄列
-->
<template>
  <div class="checkbox-detection-list">
    <div>
      <p class="search" style="margin-right:2rem;">搜索检测项：
        <el-input class="searchInput" placeholder="检测项中文" v-model="keys" @mousedown.stop.native @keydown.enter.native="handleIconClick('',false)" @click.stop.native>
          <el-button slot="append" :icon="searchIcon" @click="handleIconClick('',false)"></el-button>
        </el-input>
      </p>
      <div class="content-box">
        <div class="tables">
          <el-tabs v-model="currentTypeFilter" @tab-click="handleClick" slot="title">
            <!-- <el-tab-pane :disabled="isDisabled('COMMON_DISEASES')" label="常见疾病" name='COMMON_DISEASES'></el-tab-pane> -->
            <el-tab-pane label="全部" name=' '></el-tab-pane>
            <el-tab-pane label="常见疾病" name='COMMON_DISEASES'></el-tab-pane>
            <el-tab-pane label="高危遗传病" name='GENETIC_DISEASES'></el-tab-pane>
            <el-tab-pane label="罕见病" name='RARE_DISEASES'></el-tab-pane>
            <el-tab-pane label="药物基因组" name='PHARMACOGENOMICS'></el-tab-pane>
            <el-tab-pane label="生活方式" name='LIFE_STYLE'></el-tab-pane>
            <el-tab-pane label="祖源" name='ANCESTRY'></el-tab-pane>
          </el-tabs>
          <wt-paged-table ref="tables" :on-request-data="getTableData" :total-size="totalSize" :page-size="pageSize" :refresh="true">
            <el-table ref="table1" :data="data" border style="width: 100%;" @select="selectRow" @selection-change="handleSelectionChange" :row-key="getRowKeys" :row-class-name="setClass">
              <el-table-column type="expand">
                <template slot-scope="props" v-if="props.row.detectionItemCorpus && props.row.configs">
                  <p class="config" v-if="props.row.detectionItemCorpus.length">知识库配置</p>
                  <el-radio-group v-model="props.row.bindCorpusId" class="marginL" @change="rowChange(props.row)">
                    <el-radio :label="item.id" v-for="(item,index) in props.row.detectionItemCorpus" :key="index">{{item.corpusName || item.chineseName}}</el-radio>
                  </el-radio-group>
                  <div class="config">
                    <p v-if="props.row.configs.length">计算配置</p>
                    <div v-for="(configType,i) in allConfigType" :key="i">
                      <p v-if="props.row.configs.filter(e=>e.type===configType).length" class="p-margin">
                        <el-checkbox v-model="props.row[configType]" @change="typeChange(props.row,configType)">{{formatConfigType(configType)}}</el-checkbox>
                      </p>
                      <el-radio-group @change="rowChange(props.row,configType)" v-model="props.row['detectionItemConfigId_'+configType]" class="marginL ver" v-if="props.row.configs.filter(e=>e.type===configType).length">
                        <el-radio :label="item.id" v-for="(item,index) in props.row.configs.filter(e=>e.type===configType)" :key="index">{{getLabel(item)}}</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column type="selection" width="55" :reserve-selection="true" :selectable="selectable"></el-table-column>
              <el-table-column prop="id" label="id">
              </el-table-column>
              <el-table-column prop="chineseName" label="中文名称">
              </el-table-column>
              <el-table-column prop="category" label="分类">
                <template slot-scope="scope">
                  {{formatDetectionCategory(scope.row.category)}}
                </template>
              </el-table-column>
            </el-table>
          </wt-paged-table>
        </div>
        <!-- <div class="showSelected" v-if="this.selectedDataCopy.length">
          <h3>已勾选：</h3>
          <div>
            <span v-for="(item,index) in this.selectedDataCopy" :key="index">{{item.chineseName}}</span>
          </div>
        </div> -->
      </div>

    </div>
  </div>
</template>
<script>
import { formatDetectionCategory, formatConfigType, formatConfigSex } from 'enumeration/lab-order.js'
import { ConfigType } from 'json/lab-order'
const allConfigType = ConfigType.map(e => e.key)
export default {
  name: 'checkbox-lot-detail-list',
  props: ['otherColumn', 'selected', 'category', 'seeDetection'],
  data () {
    return {
      pageSize: 10,
      totalSize: 10,
      data: [],
      selectedDataCopy: [], // this.formatInData(this.selected),
      // 搜索
      searchIcon: 'el-icon-search',
      keys: '',
      currentTypeFilter: this.category || ' ',
      currentParams: {},
      copySelected: JSON.parse(JSON.stringify(this.selected)),
      newSelected: [],
      resetPage: false,
      allConfigType: allConfigType
    }
  },
  watch: {
    'selectedDataCopy': {
      handler: function (newVal) {
        if (newVal) {
          // this.getNewSelected(newVal)
          console.log('---emit', newVal)
          this.$emit('getSelected', newVal)
        }
      },
      deep: true
    },
    'selected': {
      handler: function (newVal) {
        console.log('newVal', newVal)
        this.formatInData(newVal)
      },
      deep: true
    },
    category (val) {
      if (val) {
        this.handleFilter(val)
      } else {
        this.currentTypeFilter = ' '
      }
    },
    seeDetection (val) {
      if (val.name) {
        this.handleIconClick(val.name)
      } else {
        this.keys = ''
        this.currentParams = {}
        this.$refs.tables.load()
      }
    }
  },
  methods: {
    formatDetectionCategory,
    formatConfigType,
    formatConfigSex,
    getNewSelected (allSelected) {
      this.newSelected = []
      let oldSelected = this.copySelected.map(e => e.id || e.detectionItemId)
      allSelected.forEach(e => {
        if (!oldSelected.includes(e.id)) {
          this.newSelected.push(e)
        }
      })
    },
    getRowKeys (row) {
      return row.id
    },
    isDisabled (type) {
      if (!this.category) return false

      if (!type) return true
      if (type === this.category) return false
      return true
      // return false
    },
    selectable (row, index) {
      // let getInIds = this.copySelected.map(e => e.id || e.detectionItemId)
      // if (getInIds.includes(row.id)) {
      //   row.canNotExpend = true
      //   return false
      // }
      // return true
      return true
    },
    setClass ({ row, rowIndex }) {
      if (row.canNotExpend) {
        return 'not-expend'
      }
      return ''
    },
    async recurTest (index, length, data) {
      console.log('ata', data)
      if (length) {
        data[index].id = data[index].detectionItemId || data[index].id
        data[index].chineseName = data[index].name || data[index].chineseName
        // 新接口
        try {
          let detectionRes = await this.$store.dispatch('getDetectionWithCorpusAndConfig', data[index].id)
          console.log('detectionRes', detectionRes)
          let detectionConfigs = detectionRes.data.configs || []
          console.log('detectionConfigs', detectionConfigs)
          detectionConfigs.forEach(ele => {
            data[index].detectionItemConfigIds.forEach(e => {
              if (ele.id === e) {
                data[index][ele.type] = true
                data[index]['detectionItemConfigId_' + ele.type] = e
              }
            })
          })
          let detectionCorpus = detectionRes.data.detectionItemCorpus
          data[index].detectionItemCorpus = detectionCorpus || []
          data[index].configs = detectionConfigs || []
          data[index].category = detectionRes.data.category
          this.contrlDetectionCheckbox(data[index])
          console.log(detectionRes)
        } catch (err) {
          console.log(err)
          this.$message.warning(err)
        }
      }

      console.log('第' + (index) + '次循环')
      if (++index < length) {
        this.recurTest(index, length, data)
      } else {
        console.log('-------------------------------------------------------over')
      }
    },
    formatInData (arr) {
      // this.reload()
      if (!arr.length) {
        // this.reset()
        console.log('this.selectedDataCopy-----------aa--', this.selectedDataCopy)
        this.selectedDataCopy.forEach(ele => {
          this.deleteTargetRow(ele)
        })

        // this.selectedDataCopy = []
      } else {
        arr.forEach(e => {
          e.id = e.detectionItemId || e.id
          e.chineseName = e.name || e.chineseName
          e.getIn = true
        })
        this.selectedDataCopy = JSON.parse(JSON.stringify(arr))
      }
    },
    reset () {
      this.keys = ''
      this.reload()
      this.$refs.table1.clearSelection()
    },
    // 分页之后对已选中的数据进行处理
    handleData (pageData) {
      let selectedIds = this.selectedDataCopy.map(e => e.id)
      let getInDataIds = this.selectedDataCopy.filter(e => e.getIn === true).map(e => e.id)
      let needRecurTest = []
      console.log('getInDataIds', getInDataIds)
      pageData.forEach((ele, index) => {
        // 对当前已经勾选的数据进行勾选渲染
        if (selectedIds.includes(ele.id)) {
          let targetData = this.selectedDataCopy.filter(e => e.id === ele.id)[0]
          this.$set(pageData, index, targetData)
        } else {
          this.deleteTargetRow(ele)
        }

        if (getInDataIds.includes(ele.id)) {
          console.log()
          needRecurTest.push(this.selectedDataCopy.filter(e => e.id === ele.id)[0])
        }
      })
      // console.log('needRecurTest-----', needRecurTest)
      // 对传进的数据进行相应的勾选
      if (needRecurTest.length) {
        // 对传入的非现在勾选的数据进行勾选
        this.recurTest(0, needRecurTest.length, needRecurTest)
      }
    },
    // 只对新勾选的数据进行添加操作，取消勾选的删除操作放在每行操作的数据里
    handleSelectionChange (val) {
      console.log('val------------', val)
      let newSelected = val.filter(e => !e.getIn).map(e => e.id)
      val.forEach(ele => {
        if (newSelected.includes(ele.id)) {
          this.selectedDataCopy.unshift(ele)
        } else {
          this.selectedDataCopy.push(ele)
        }
        // 数组去重
        this.selectedDataCopy = Array.from(new Set(this.selectedDataCopy))
        // }
      })
      // console.log('this.selectedDataCopy=======', this.selectedDataCopy)
    },
    deleteTargetRow (row) {
      // console.log('-----------------row-------r-r-r-')
      this.$refs.table1.toggleRowSelection(row, false)
      // 从勾选列表中删除
      this.selectedDataCopy.forEach((e, index) => {
        if (e.id === row.id) {
          this.selectedDataCopy.splice(index, 1)
        }
      })
    },
    setCongifgValue (row) {
      allConfigType.forEach(type => {
        let targetConfigs = row.configs.filter(e => e.type === type)
        if (targetConfigs.length) {
          this.$set(row, type, true)
          this.$set(row, `detectionItemConfigId_${type}`, targetConfigs[0].id)
        }
      })
    },
    selectRow (rows, row) {
      if (!row.detectionItemCorpus.length || !row.configs.length) {
        this.$message.warning('请检查该检测项的知识库或配置是否存在')
        // 从勾选列表中删除,并设置当前行为取消勾选状态
        this.deleteTargetRow(row)
        return
      }
      let flag = 0
      console.log('rows', rows)
      if (rows.map(e => e.id).includes(row.id)) {
        flag = 1
      }
      if (flag) {
        // 选中的话
        if (row.detectionItemCorpus.length) {
          this.$set(row, 'bindCorpusId', row.detectionItemCorpus[0].id)
        }
        if (row.configs.length) {
          // 给各个类型的配置进行设置勾选
          this.setCongifgValue(row)
          this.setDetectionItemConfigIds(row)
        }
      } else {
        // 不选中，表单重置
        row.bindCorpusId = ''
        this.setConfigNull(row)
        // 从勾选列表中删除
        console.log('------------eee--ss-el')
        this.deleteTargetRow(row)
        // this.selectedDataCopy.forEach((e, index) => {
        //   if (e.id === row.id) {
        //     this.selectedDataCopy.splice(index, 1)
        //   }
        // })
      }
    },
    setConfigNull (row) {
      allConfigType.forEach(type => {
        row[type] = false
        row['detectionItemConfigId_' + type] = ''
      })
    },
    typeChange (data, type) {
      let targetConfigs = data.configs.filter(e => e.type === type)
      let prop = 'detectionItemConfigId_' + type
      if (data[type] && targetConfigs.length) {
        this.$set(data, prop, targetConfigs[0].id)
        if (data.bindCorpusId) {
          this.$refs.table1.toggleRowSelection(data, true)
        }
      } else {
        this.$set(data, type, false)
        this.$set(data, prop, '')
        this.contrlDetectionCheckbox(data)
      }
      console.log(data)
    },
    // 控制检测项的多选
    contrlDetectionCheckbox (data) {
      this.setDetectionItemConfigIds(data)
      if (data.bindCorpusId && data.detectionItemConfigIds.length) {
        this.$refs.table1.toggleRowSelection(data, true)
      } else {
        this.deleteTargetRow(data)
      }
    },
    setDetectionItemConfigIds (row) {
      let allConfig = allConfigType.map(type => {
        return `detectionItemConfigId_${type}`
      })
      let detectionItemConfigIds = []
      allConfig.forEach(e => {
        if (row[e]) {
          detectionItemConfigIds.push(row[e])
        }
      })
      this.$set(row, 'detectionItemConfigIds', detectionItemConfigIds)
    },
    rowChange (data, type = '') {
      console.log('rowChange', data)
      let copyData = JSON.parse(JSON.stringify(data))
      if (type) {
        this.$delete(data, `detectionItemConfigId_${type}`)
        this.$set(data, `detectionItemConfigId_${type}`, copyData[`detectionItemConfigId_${type}`])
      }
      if (data.configs.length) {
        this.setConfigTrue(data)
        this.contrlDetectionCheckbox(data)
      }
    },
    setConfigTrue (data) {
      allConfigType.forEach(type => {
        if (data[`detectionItemConfigId_${type}`]) {
          this.$set(data, type, true)
        }
      })
    },
    getLabel (item) {
      return '配置库名称：' + item.configSuiteName + '  实验室检测平台：' + item.sequencingTechnology + ' 计算模型：' + formatConfigType(item.type) + ' 适用性别：' + formatConfigSex(item.gender) + ' 位点数量：' + item.sitesCount
    },
    buildFilterParams (page, params = {}) {
      if (Object.keys(params).length) {
        params['page'] = page
        params['size'] = this.pageSize
        params.getAllConfigs = true
        params.getCorpus = true
        if (this.seeDetection.name) {
          params.chineseName = this.seeDetection.name
          this.keys = this.seeDetection.name
        } else if (this.keys) {
          params.chineseName = this.keys
        } else {
          params.chineseName = null
        }
        if (this.currentTypeFilter) {
          params.category = this.currentTypeFilter
        } else {
          params.category = null
        }
        return params
      } else {
        let data = {
          page: page,
          size: this.pageSize,
          category: this.currentTypeFilter,
          getAllConfigs: true,
          getCorpus: true
        }
        if (this.seeDetection.name) {
          data.chineseName = this.seeDetection.name
          this.keys = this.seeDetection.name
        } else if (this.keys) {
          data.chineseName = this.keys
        } else {
          params.chineseName = null
        }
        return data
      }
    },
    getTableData (page, next) {
      let data = this.buildFilterParams(page, this.currentParams)
      this.$store.dispatch('getDetectionListByFilter', data).then(res => {
        next(res.data)
        this.data = res.data
        this.totalSize = res.totalNumber
        this.handleData(this.data)
      }).catch(err => {
        this.$refs.tables.showReTry()
        this.$message.error(err)
      })
    },
    // 刷新列表
    reload () {
      this.$nextTick(() => {
        this.currentParams = {}
        this.$refs.tables.load()
      })
      this.selectedData = []
    },

    // 搜索
    async handleIconClick (text) {
      this.currentTypeFilter = ' '
      this.$refs.tables.resetPage()
    },
    handleClick (tab) {
      this.$refs.tables.resetPage()
    },
    // 清空所选的数据
    clearSelected () {
      this.selectedDataCopy = []
    },
    handleFilter (category) {
      this.currentTypeFilter = category
      let tab = {
        name: category
      }
      this.handleClick(tab)
    }
  },
  mounted () {
    if (!this.selected.length) {
      this.reset()
    } else {
      this.formatInData(this.selected)
    }
    if (this.category) {
      this.handleFilter(this.category)
    } else {
      this.currentTypeFilter = ' '
    }
  }
}
</script>
<style lang="less">
.checkbox-detection-list{
  .content-box{
    display: flex;
  }
  .el-tabs__nav-scroll{
    text-align: center;
  }
  .el-tabs__nav{
    display: inline-block;
    float: none;
  }
  .tables{
    width:50%;
    margin-top:10px;
    .el-table__empty-block{
      min-height:49px;
    }
    .el-pagination{
      // width:100%;
      padding-top:20px;
    }
    .el-table .cell{
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  }
  .el-input{
    width:500px;
  }
  .config{
    padding-left: 55px;
    margin: 10px 0;
  }
  .marginL{
    margin-left: 80px;
  }
  .p-margin{
    margin-left: 25px;
  }
  .showSelected{
    padding-left: 30px;
    width:47%;
    span{
      width:250px;
      display: inline-block;
      white-space:nowrap;
      overflow:hidden;
      text-overflow:ellipsis;
    }
  }
  th .el-checkbox{
    display: none;
  }
  .ver{
    .el-radio{
      display:block;
      line-height: 30px;
    }
    .el-radio + .el-radio {
      margin-left:0;
    }
  }
  .not-expend .el-table__expand-column .cell {
    display: none;
  }
  // ----------------------
  .tables{
    width: 90%;
    margin:0 auto;
    .el-input{
      max-width: 50px;
    }
  }

  .el-table{
    width: 100%
  }
  .el-tabs__nav-wrap{
    display: inline-block;
  }
  .el-tabs__header{
    text-align: center;
  }

}

</style>
